import React, { useState, useEffect, useRef } from "react";
import { CountdownTimer } from "./CountdownTimer";
import { Button, Col, Row } from "antd";
import bgDesktopVideo from '../assets/videos/bg-desktop3.mp4'
import bgoverlayvideo from '../assets/videos/overlaybgvideo6.mp4'
import rightbg from '../assets/videos/rightbg.mp4'

export const Header = () => {
  // Use ISO format for better compatibility
  const deadline = "2026-04-09T15:00:00";

  const [videoHeight, setVideoHeight] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [showEventInfo, setShowEventInfo] = useState(false);
  const [showCountdownPart, setShowCountdownPart] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const [hideVideo, setHideVideo] = useState(false);


  useEffect(() => {
    const logoTimer = setTimeout(() => {
      setShowLogo(true);
    }, 1000); // 1 second

    const venueTimer = setTimeout(() => {
      setShowEventInfo(true);
    }, 2000); // 2 seconds

    const countdownTimer = setTimeout(() => {
      setShowCountdownPart(true);
    }, 3000); // 3 seconds

    return () => {
      clearTimeout(logoTimer);
      clearTimeout(venueTimer);
      clearTimeout(countdownTimer);
    };
  }, []);
  const headerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCountdown(true);
    }, 1); // 10 seconds delay

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (!headerRef.current || !containerRef.current) return;

    const updateHeight = () => {
      const headerHeight = headerRef.current.offsetHeight;
      containerRef.current.style.height = `${headerHeight}px`;
      setVideoHeight(headerHeight)
    };

    // Initial set
    updateHeight();

    // Observe size changes
    const observer = new ResizeObserver(() => {
      updateHeight();
    });

    observer.observe(headerRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);
  const isMobileScreen = window.innerWidth <= 768;
  return (
    <div id="whatisConnect" ref={containerRef} className="header-container">
      <video
        autoPlay
        muted
        playsInline
        preload="auto"
        className={`background-video ${videoEnded ? "fade-out" : ""}`}
        onLoadedData={() => {
          const isMobile = window.innerWidth <= 768;
          if (!isMobile) {
            document.body.style.overflow = "hidden";
          }
        }}
        onEnded={(e) => {
          console.log("Video ended at:", e.target.currentTime, "seconds");
          setVideoEnded(true);

          setTimeout(() => {
            setHideVideo(true);
            document.body.style.overflowY = "scroll";
          }, 1000); // same duration as CSS transition
        }}
        style={{ display: hideVideo||isMobileScreen ? "none" : "block" }}
      >
        <source src={bgoverlayvideo} type="video/mp4" />
      </video>
      
      <div className="full-width-header" ref={headerRef}>
        <span className="left-section">
          <Row gutter={[16, 16]}>

            <Col span={24} className={`header-logo-img-box fade ${showLogo ? "show" : ""}`}>
              <img src="/img/logoSmall.png" alt="logo" style={{ cursor: 'pointer' }} onClick={() => {
                console.log('clicked logo');
                const section = document.getElementById("ContentPartPage");
                if (section) {
                  section.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                }
              }} />
            </Col>

            <Col span={24} style={{ textAlign: 'center' }}>

              {/* <p style={{ textAlign: 'justify' }}>
                Welcome to the 7th edition of Flipkart Connect - Flipkart Ads’ annual flagship event.
                Designed for the leaders shaping India’s digital commerce landscape, this event brings
                together top brands and agencies to decode the future of e-retail.
              </p>

              <p style={{ textAlign: 'justify' }}>
                This year’s theme, "The Next Frontier," bridges the gap between tomorrow's consumer
                insights and the technology needed to capture them. Discover how Flipkart’s advanced
                ad-tech turns your boldest ambition into reality by completely collapsing the distance
                between a shopper's first spark of inspiration and their final purchase.
              </p>

              <p style={{ textAlign: 'justify' }}>
                Join us for an evening of forward-looking strategies, the celebration of excellence,
                and meaningful partnerships that will define your brand's next phase of growth.
              </p> */}
              {/* <div className="hero-event-info">
                <div><strong>Date:</strong> 9<sup>th</sup> April 2026</div>
                <div><strong>Time:</strong> 3:00 PM – 9:00 PM</div>
                <div><strong>Venue:</strong><a href="https://maps.app.goo.gl/7nw5DAb7mNTNfS267?g_st=ic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="venue-link"> Pullman New Delhi Aerocity</a></div>
              </div> */}
            </Col>


            <Col span={24}>
              <div className={`countdownContainer fade ${showCountdownPart ? "show" : ""}`}>
                {/* <Button href="#signup" className="header-left-rsvpbtn" type="primary" size="large">
                </Button> */}
                {showCountdownPart && <CountdownTimer deadline={deadline} />}

              </div>

            </Col>
            <Col
              span={24}
              style={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}
            //   className={`fade ${showEventInfo ? "fade-in" : ""}`}
            >
              <div className="hero-event-info">
                <div className="event-line">
                  <span>Date: 9<sup>th</sup> April</span>
                  <span className="divider mobdividerclose">|</span>
                  <span>Time: 3:00 PM – 9:00 PM</span>
                  <span className="divider mobdividerclose">|</span>
                  <span>
                    Venue:{" "}
                    <a
                      href="https://maps.app.goo.gl/7nw5DAb7mNTNfS267?g_st=ic"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="venue-link"
                    >
                      Pullman, New Delhi, Aerocity
                    </a>
                  </span>
                </div>
              </div>
            </Col>

          </Row>
        </span>
        <span className="right-section">
          <video
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src={rightbg} type="video/mp4" />
          </video>
        </span>
      </div>

    </div>
  );
};